const isRoundNumber = (num: number) => num % 1 === 0;

/**
 *
 * Function used to find adjusted scale value which will give rounded values when applied to width and height
 *
 * @param scale - initial scale value which will give not rounded values when applied to width and height
 * @param width - initial width
 * @param height - initial height
 * @returns
 */
export const adjustScale = (scale: number, width: number, height: number) => {
  let adjustedScale = scale;
  while (
    adjustedScale > 0 &&
    (!isRoundNumber(width * adjustedScale) ||
      !isRoundNumber(height * adjustedScale))
  ) {
    // tis is needed to fix issues with 64-bit floating point numbers
    adjustedScale = (Math.round(adjustedScale * 100) - 1) / 100;
  }

  if (adjustedScale <= 0) {
    return scale;
  }

  return adjustedScale;
};
